<template>
  <div>
    <v-card class="mt-4">
      <v-toolbar
        light
        color="white"
        class="elevation-2"
      >
        <v-toolbar-title>
          Dostępne katalogi
        </v-toolbar-title>
      </v-toolbar>
      <div v-if="!busy">
        <div class="py-4" v-if="directories">
          <div
            v-for="(singleDir, index) in directories"
            :key="index"
          >
            <DirectoriesItem
              :dir="singleDir"
            />
          </div>
        </div>
        <v-divider></v-divider>
        <v-card-actions class="py-4" :class="paddingClass">
          <v-spacer></v-spacer>
          <v-btn
            color="primary lighten-2"
            flat="flat"
            :loading="cancelBusy"
            :disabled="buttonBusy || busy || cancelBusy"
            @click="cancelChanges"
          >
            Anuluj
          </v-btn>

          <v-btn
            :loading="buttonBusy"
            :disabled="buttonBusy || busy || cancelBusy"
            @click="showAccessDialog"
            color="primary"
          >
            Zapisz
          </v-btn>
        </v-card-actions>
      </div>
      <div class="users_loader">
        <div class="py-4 text-xs-center" v-if="busy">
          <v-progress-circular
            :size="30"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </div>
    </v-card>
    <AccessDialog @refresh-list="getInitAcceses" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { accessManage } from '../../../repository/users';
import AccessDialog from './../Dialog/AccessDialog.vue';
import DirectoriesItem from './DirectoriesItem.vue';

export default {
  name: 'user-directories-list',
  data: () => ({
    busy: false,
    cancelBusy: false,
    buttonBusy: false,
    directories: null,
  }),
  components: {
    DirectoriesItem,
    AccessDialog,
  },
  computed: {
    userId() {
      return this.$route.params.id;
    },
    paddingClass() {
      return this.$vuetify.breakpoint.smAndDown ? 'px-3' : 'px-4';
    },
  },
  methods: {
    ...mapActions('users', [
      'clearDirAccess',
      'setDialogVisbility',
    ]),
    showAccessDialog() {
      this.setDialogVisbility({
        type: 'access',
        userId: this.userId,
      });
    },
    async getAccessManage() {
      this.directories = await accessManage(this.userId);
      this.clearDirAccess();
      this.directories = this.directories.data.data.items;
    },
    async cancelChanges() {
      this.cancelBusy = true;
      try {
        await this.getAccessManage();
        this.cancelBusy = false;
      } catch (e) {
        this.cancelBusy = false;
      }
    },
    async getInitAcceses() {
      this.busy = true;
      try {
        await this.getAccessManage();
        this.busy = false;
      } catch (e) {
        this.busy = false;
      }
    },
  },
  mounted() {
    this.getInitAcceses();
  },
};
</script>
